import {
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedDropDownRHFWithLabel,
    LabelPosition,
    RHookFormDatePicker,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { CountryService } from "../../services/common/CountryService";
import { Grid } from "@mui/material";
import { useNavigateToLogout } from "../../common/Common";
import { useQuery } from "@tanstack/react-query";

interface IWSIBCodeListHeader {
    setStateRunGetListAPICall: (value: boolean) => void,
    setIsLoadingProvinceDDL: (value: boolean) => void,
    countryDDL: any[],

}

export const WSIBCodeListHeader: React.FC<
    IWSIBCodeListHeader
> = ({
    setStateRunGetListAPICall, setIsLoadingProvinceDDL, countryDDL
}) => {

        const navigateToLogout = useNavigateToLogout();
        const [provinceDDL, setProvinceDDL] = useState<any>(undefined);
        useEffect(() => {
            if (countryDDL && Array.isArray(countryDDL)) {
                const canada = countryDDL.find(
                    (item: any) => item.label === "Canada" || "canada"
                );
                if (canada) {
                    (async () => {
                        setIsLoadingProvinceDDL(true)
                        try {
                            const response = await CountryService.getProvinceOrStateDDL(
                                navigateToLogout,
                                canada.value,
                                "Province"
                            );
                            setProvinceDDL(response);
                        } catch (err) { } finally { setIsLoadingProvinceDDL(false) }
                    })();
                }
            }
        }, [countryDDL])

        return (
            <>
                <Grid
                    container
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    sx={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderBottom: 0,
                        borderRadius: "2px 2px 0 0",
                        padding: "31px 20px 1rem 20px",
                        marginBottom: "0px!important",
                    }} columnSpacing={2}>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}

                        sx={{
                            color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
                            "& .calenderWrapper ": {
                                marginBottom: "0!important",
                                minWidth: "178px!important"

                            }
                        }}>
                        {countryDDL && provinceDDL && <EnhancedDropDownRHFWithLabel
                            testId={"canada-provinces"}
                            selectName={"provinceId"}
                            items={provinceDDL ?? []}
                            label={"Province"}
                            onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
                            // showEmpty
                        />}

                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}> </Grid>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
                        sx={{
                            "& .calenderWrapper ": {
                                marginBottom: "0!important",
                                minWidth: "178px!important"
                                // fontSize: ".875rem" 
                            }
                        }}
                    >
                        <RHookFormTextFieldWithLabel
                            label="Code"
                            id="code"
                            testId={`code`}
                            labelPosition={LabelPosition.Top}
                        />

                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}> </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
                        sx={{
                            "& .calenderWrapper ": {
                                marginTop: "19px!important",
                                marginBottom: "0!important",
                                minWidth: "178px!important"

                            },

                        }}>
                        <RHookFormTextFieldWithLabel
                            label="Label"
                            id="label"
                            testId={`label`}
                            labelPosition={LabelPosition.Top}
                        />


                    </Grid>

                    <Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}> </Grid>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}

                    >
                        <RHookFormTextFieldWithLabel
                            label="Descirption"
                            id="description"
                            testId={`description`}
                            labelPosition={LabelPosition.Top}

                        />

                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 0.5, lg: 0.5, xl: 0.5 }}> </Grid>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
                        sx={{
                            "& .enhanced-button": {
                                marginTop: "1.5rem!important"
                            }
                        }}
                    >
                        <EnhancedButtonPrimeReact
                            label="Apply Filter"
                            raised
                            type="submit"
                            severity={EnhancedButtonPrimeReactSeverity.Secondary}
                        // onClickHandler={() => setStateRunGetListAPICall(true)}
                        />

                    </Grid>

                </Grid >

            </>
        );
    };
